// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__oQOIp","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__334PD"};